import React, { useState } from 'react';
import { Modal } from './Modal';
import { PrivacyContent, TermsContent } from './LegalContent';
export function Footer() {
  const [openModal, setOpenModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="border-t border-border bg-background py-12 px-6 text-center" data-id="element-91">
        <div className="max-w-4xl mx-auto" data-id="element-92">
          <div className="h-[1px] w-12 bg-blood mx-auto mb-8" data-id="element-93"></div>

          <div className="flex items-center justify-center gap-6 mb-6 flex-wrap" data-id="element-94">
            <button onClick={() => setOpenModal('privacy')} className="text-foreground/60 hover:text-blood transition-colors font-sans text-sm uppercase tracking-widest" data-id="element-95">
              Política de Privacidad
            </button>
            <span className="text-foreground/20" data-id="element-96">·</span>
            <button onClick={() => setOpenModal('terms')} className="text-foreground/60 hover:text-blood transition-colors font-sans text-sm uppercase tracking-widest" data-id="element-97">
              Términos de Uso
            </button>
          </div>

          <p className="text-foreground/40 font-sans text-sm" data-id="element-98">
            © {new Date().getFullYear()} El Código de la Sombra. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>

      <Modal isOpen={openModal === 'privacy'} onClose={() => setOpenModal(null)} title="Política de Privacidad" data-id="element-99">
        <PrivacyContent data-id="element-100" />
      </Modal>

      <Modal isOpen={openModal === 'terms'} onClose={() => setOpenModal(null)} title="Términos de Uso" data-id="element-101">
        <TermsContent data-id="element-102" />
      </Modal>
    </>;
}